module.exports = "../dist/frontend/icons/logo/white-blue.svg?083cdf1a8137909a03677b2d1fac6593";